import React, { useState } from 'react';
import { FaStore, FaLock, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ConnectStoreModal = ({ isOpen, onClose,setIsFetched }) => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    store_domain: '',
    Shopify_access_token: '',
    Shopify_api_version: '',
    shop_name: '',
    type: 'shopify',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.store_domain) newErrors.store_domain = 'Store domain is required';
    if (!formData.Shopify_access_token) newErrors.Shopify_access_token = 'Access token is required';
    if (!formData.Shopify_api_version) newErrors.Shopify_api_version = 'API version is required';
    if (!formData.shop_name) newErrors.shop_name = 'Shop name is required';
    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_CREATE_STORE}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`, // Adjust if token is elsewhere
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to connect store');
      }

      toast.success("Store added successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      setIsFetched(true)
      setFormData({
        store_domain: '',
        Shopify_access_token: '',
        Shopify_api_version: '',
        shop_name: '',
        type: 'shopify',
      })
      onClose(); // close modal
    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-bold text-gray-800">Connect Shopify Store</h3>
            <button onClick={() => onClose(false)} className="text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>
{/* Shop Name */}
<div className="mb-6">
            <label className="block text-gray-700 mb-1">Store Name</label>
            <input
              type="text"
              name="shop_name"
              value={formData.shop_name}
              onChange={handleChange}
              placeholder="Your store name"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.shop_name && <p className="text-red-500 text-sm mt-1">{errors.shop_name}</p>}
          </div>
          {/* Store Domain */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Store Domain</label>
            <div className="flex">
              <input
                type="text"
                name="store_domain"
                value={formData.store_domain}
                onChange={handleChange}
                placeholder="example.myshopify.com"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 "
              />
              {/* <span className="inline-flex items-center px-3 rounded-r-lg border border-l-0 bg-gray-50 text-gray-500">
                .myshopify.com
              </span> */}
            </div>
            {errors.store_domain && <p className="text-red-500 text-sm mt-1">{errors.store_domain}</p>}
          </div>

          {/* Access Token */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Access Token</label>
            <input
              type="text"
              name="Shopify_access_token"
              value={formData.Shopify_access_token}
              onChange={handleChange}
              placeholder="Enter your access token"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.Shopify_access_token && <p className="text-red-500 text-sm mt-1">{errors.Shopify_access_token}</p>}
          </div>

          {/* API Version */}
          <div className="mb-4">
            <label className="block text-gray-700 mb-1">Shopify API Version</label>
            <input
              type="text"
              name="Shopify_api_version"
              value={formData.Shopify_api_version}
              onChange={handleChange}
              placeholder="e.g., 2024-04"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.Shopify_api_version && <p className="text-red-500 text-sm mt-1">{errors.Shopify_api_version}</p>}
          </div>

          

          {/* Buttons */}
          <div className="flex justify-end">
            <button
              onClick={() => onClose(false)}
              className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg mr-3 hover:bg-gray-300 transition duration-300"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:opacity-90 transition duration-300"
            >
              {loading ? 'Please wait...' : 'Connect Store'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectStoreModal;
